<div
    class="editorial-common"
    [ngClass]="{ 'editorial-immersive': (immersiveContentColor$ | async) }"
    [style.background-color]="immersiveContentColor$ | async"
    [class.keyboard-navigation]="layoutFacade.keyboardNavigation$ | async">
    @for (paragraph of paragraphs$ | async; track paragraph; let index = $index) {
    <ng-template
        [hStoryParagraph]="paragraph"
        [hStoryParagraphShouldPreloadMedia]="shouldPreloadMedia(index)"
        [hStoryParagraphIsFirst]="index === 0"></ng-template>
    }
</div>
